
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"fill":"none","viewBox":"0 0 18 18"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{staticClass:"i-cog_2",attrs:{"stroke":"#798f8f","stroke-linecap":"round","stroke-linejoin":"round","stroke-miterlimit":"10","d":"M17.413 10.05V7.941l-2.367-.425a6.7 6.7 0 0 0-.727-1.73l1.366-1.987L14.2 2.314l-1.99 1.397c-.591-.348-1.7-.699-1.7-.699l-.44-2.425h-2.11l-.44 2.425c-.607.168-1.17.366-1.685.681L3.849 2.332 2.361 3.725l1.352 2.123a5.4 5.4 0 0 0-.7 1.7l-2.426.424v2.124l2.412.439c.165.61.386 1.161.71 1.695l-1.35 1.965 1.458 1.523 2.002-1.366c.53.334 1.092.562 1.7.727l.425 2.334h2.11l.425-2.41a6.8 6.8 0 0 0 1.731-.7l1.988 1.366 1.486-1.485-1.366-1.987q.48-.794.727-1.73zm-8.43 2.12a3.16 3.16 0 1 1 0-6.318 3.16 3.16 0 0 1 3.162 3.159 3.16 3.16 0 0 1-3.161 3.16"}})])
          )
        }
      }
    